import { render, staticRenderFns } from "./CambiarDatosView.vue?vue&type=template&id=0f1b57c9"
import script from "./CambiarDatosView.vue?vue&type=script&setup=true&lang=js"
export * from "./CambiarDatosView.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports